import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { ButtonWithGAClickButton, ModalHeader, Typography } from 'common/components';
import { ENTRANCE_DOORS_ELEMENT_BLOCK } from '../../../../entrance-doors-constants';

type IndividualSizeProps = {
  onConsultationSignupBtnClick: () => void;
};

export const IndividualSize = ({ onConsultationSignupBtnClick }: IndividualSizeProps) => (
  <>
    <ModalHeader title="Индивидуальные размеры" />
    <ModalContent>
      <Typography variant="m" size="body_long">
        Мы&nbsp;изготавливаем двери для любых современных домов, включая новостройки, а&nbsp;также
        в&nbsp;сталинки, хрущёвки и&nbsp;в&nbsp;старые панельные дома.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={ENTRANCE_DOORS_ELEMENT_BLOCK}
        elementName="Индивидуальные размеры"
        elementText="Оставить заявку"
        onClick={onConsultationSignupBtnClick}
        wide>
        Оставить заявку
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
